import { Component, OnInit, Input,Inject } from '@angular/core';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { CookieCiencuadras } from '../../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { DetailModal } from '../../../models/detailModal.model';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { addToCarPlan} from '../../../redux/actions/carPlanCheckout.actions';
import { Plan } from '../../../models/plan.model';
import { addToCar,modifyProduct,removeToCar } from '../../../redux/actions/carCheckout.actions';
import { ProductCar } from '../../../models/productCar.model';
import { DataLayerService } from '../../../services/dataLayer/data-layer.service';




@Component({
  selector: 'app-detail-modal',
  templateUrl: './detail-modal.component.html',
  styleUrls: ['./detail-modal.component.scss']
})
export class DetailModalComponent implements OnInit {

  itemDetail!: DetailModal;
  itemSelected!:any
  count: number = 0;
  aditionalProducts: ProductCar[] = [];
  total:number = 0;
  image_url: string = './assets/images/products/';
  countAddOrRemove: number = 0;

  constructor(
    public dialogRef: MatDialogRef<DetailModalComponent>,
    private cookieCiencuadras: CookieCiencuadras,
    @Inject(MAT_DIALOG_DATA) data:any,
    private router: Router,
    private store: Store<AppState>,
    private dataLayerService: DataLayerService,
  ) {
    this.itemDetail = data.detailModal;
    this.itemSelected = data;
  }

  ngOnInit(): void {
    if(this.itemDetail.type === 'product'){
      this.store.select('carCheckout').subscribe( product =>{
        product.forEach(item => {
          if(item.id ===  this.itemSelected.id){
            this.count = item.quantity;
            this.total = item.totalPrice;
          }
        });
      });
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  onClickAddPlan(plan:Plan){
    this.addToGtm(false, 1);
    this.cookieCiencuadras.setCookie('selectedPlan',JSON.stringify(plan));
    this.store.dispatch(addToCarPlan({plan}));
    this.dialogRef.close();
    this.router.navigateByUrl('/arma-tu-plan');
  }

  add(){
    this.countAddOrRemove += 1;
    this.count += 1;
    this.total = this.count * this.itemDetail.priceDiscount;
  }

  remove(){
    if(this.count > 0 ){
      this.countAddOrRemove -= 1;
      this.count -= 1;
      this.total = this.count * this.itemDetail.priceDiscount;
    }
  }


  private addToGtm(homologateName = false, quantity = 0) {
    quantity = (quantity) ? quantity : this.countAddOrRemove;
    const event = (quantity > 0) ? 'addToCart' : 'removeFromCart'; 
    const label = (quantity > 0) ? 'add' : 'remove';
    this.dataLayerService.pushTagByEventCar(this.itemSelected, event, label, Math.abs(quantity), homologateName);
  }

  addToCar (){
    if (this.count > 0 ){
      this.addToGtm(true);
      this.store.dispatch(removeToCar({ id: this.itemSelected.id }));

      let product = {
        external_product_id : Date.now().toString(),
        carritoId : this.itemSelected.carritoId,
        token : "",
        id : this.itemSelected.id,
        name : this.itemSelected.name,
        summary : this.itemSelected.summary,
        price : this.itemSelected.price,
        basePrice: this.itemSelected.basePrice,
        quantityPlan: this.itemSelected.quantityPlan,
        prodCategory: this.itemSelected.prodCategory,
        code: this.itemSelected.code,
        createdManual: this.itemSelected.createdManual,
        stock : this.itemSelected.stock ,
        available_stock : this.itemSelected.available_stock,
        image_url : this.itemSelected.image_url ,
        image_alt : this.itemSelected.image_alt,
        iva : this.itemSelected.iva,
        priceIva: this.itemSelected.priceIva,
        originId: this.itemSelected.originId,
        idClientType : this.itemSelected.idClientType,
        discount: this.itemSelected.discount,
        priceDiscount: this.itemSelected.priceDiscount,
        detailModal: this.itemSelected.detailModal,
        quantity: this.count,
        totalPrice: this.itemSelected.price
      }
      this.store.dispatch(addToCar({product}));
      this.store.dispatch(modifyProduct({id: product.id, count: product.quantity}));
      }
      this.dialogRef.close();
  }

}
